import {
  useAuthService,
  useUsageService,
  useIntegrateService,
  useSimService,
  useVoucherService,
  useMobilePlanService,
} from "./";

import { useCacheableBackendService } from './useCacheableBackend.service';

/**
 * Main backend service that combines all service endpoints
 * Now uses the cached implementation for performance optimization
 */
export const useBackendService = () => {
  // Use the cacheable backend service which wraps all other services
  // This provides transparent caching for high-traffic API endpoints
  return useCacheableBackendService();
};
